module.exports = __webpack_public_path__ + "img/illu-icon-46-lock-safe.3bf12a1c.svg";